export default "__VITE_ASSET__DrEqXsz$__"